import { TextField } from '@mui/material';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import { InputPropsDefault, useStyles } from './styles';

const defaultMaskOptions = {
  prefix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: true,
  decimalSymbol: '.',
  decimalLimit: 2,
  integerLimit: 12,
  allowNegative: true,
  allowLeadingZeroes: false,
};

const CurrencyMask = ({ maskOptions, ...inputProps }: any) => {
  const currencyMask = createNumberMask({
    ...defaultMaskOptions,
    ...maskOptions,
  });

  return <MaskedInput mask={currencyMask} {...inputProps} />;
};

const CurrencyInput = ({
  id,
  label,
  value,
  onChange,
  error,
  required,
  fullWidth,
  disabled,
  placeholder,
  prefix,
  defaultValue,
  ...other
}: any) => {
  const classesInput = useStyles();

  return (
    <TextField
      id={id}
      variant="outlined"
      label={label}
      value={value}
      onChange={onChange}
      error={!!error}
      helperText={error ? error.message : null}
      required={required}
      fullWidth={fullWidth}
      InputLabelProps={InputPropsDefault()}
      prefix={prefix}
      {...other}
      InputProps={{
        inputComponent: CurrencyMask,
        className: classesInput.inputColor,
      }}
      disabled={disabled}
      placeholder={placeholder}
      color={'secondary'}
    />
  );
};

export default CurrencyInput;
